// extracted by mini-css-extract-plugin
export default {"container":"SetupIPACategoryLevelsCategoryLevelsButtons_container__aYGWc"};